@if (visible()) {
  <button
    type="button"
    class="chat-trigger"
    [style.bottom.px]="bottomPx"
    (click)="open($event)"
    aria-label="AI Chat öffnen"
    aria-haspopup="dialog"
    [attr.aria-expanded]="chat.isOpen()"
  >
    <span class="sparkle" aria-hidden="true"></span>
  </button>
}
